import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "./message";

import AuthService from "../services/iframeads.service";

export const addAds = createAsyncThunk(
  "iframeads/add",
  async ({ iframe, url, location, isActive }, thunkAPI) => {
    try {
      const data = await AuthService.addAds(
        iframe,
        url,
        location,
        isActive
      );
      thunkAPI.dispatch(setMessage(data.message));
      return true;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getAds = createAsyncThunk("iframeads/get", async (thunkAPI) => {
  try {
    const data = await AuthService.getAds();
    return data.docs;
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      error.toString();
    thunkAPI.dispatch(setMessage(message));
    return thunkAPI.rejectWithValue();
  }
});

export const updateAds = createAsyncThunk(
  "iframeads/update",
  async ({ id, location, isActive }, thunkAPI) => {
    try {
      const data = await AuthService.updateAds(id, location, isActive);
      thunkAPI.dispatch(setMessage(data.message));
      return data.docs;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const updateAdsData = createAsyncThunk(
  "iframeads/updateInfo",
  async ({ id, iframe, url, location, isActive }, thunkAPI) => {
    try {
      const data = await AuthService.updateAdsData(
        id,
        iframe,
        url,
        location,
        isActive
      );
      thunkAPI.dispatch(setMessage(data.message));
      return data.docs;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const deleteAds = createAsyncThunk(
  "iframeads/delete",
  async (id, thunkAPI) => {
    try {
      const data = await AuthService.deleteAds(id);
      thunkAPI.dispatch(setMessage(data.message));
      return data.docs;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

const initialState = { isLoader: false, iframeadvertise: null };

const adsSlice = createSlice({
  name: "iframeadvertisement",
  initialState,
  extraReducers: {
    [addAds.fulfilled]: (state, action) => {
      state.isLoader = false;
      state.iframeadvertise = null;
    },
    [addAds.rejected]: (state, action) => {
      state.isLoader = false;
      state.iframeadvertise = null;
    },
    [getAds.fulfilled]: (state, action) => {
      state.isLoader = false;
      state.iframeadvertise = action.payload;
    },
    [getAds.rejected]: (state, action) => {
      state.isLoader = false;
      state.iframeadvertise = null;
    },
    [updateAds.fulfilled]: (state, action) => {
      state.isLoader = false;
      state.iframeadvertise = action.payload;
    },
    [updateAds.rejected]: (state, action) => {
      state.isLoader = false;
      state.iframeadvertise = null;
    },
    [updateAdsData.fulfilled]: (state, action) => {
      state.isLoader = false;
      state.iframeadvertise = action.payload;
    },
    [updateAdsData.rejected]: (state, action) => {
      state.isLoader = false;
      state.iframeadvertise = null;
    },
    [deleteAds.fulfilled]: (state, action) => {
      state.isLoader = false;
      state.iframeadvertise = action.payload;
    },
    [deleteAds.rejected]: (state, action) => {
      state.isLoader = false;
      state.iframeadvertise = null;
    },
  },
});

const { reducer } = adsSlice;
export default reducer;
